import emotionStyled from '@emotion/styled';
import { styled } from '@mui/material';
import MuiAppBar, { type AppBarClasses } from '@mui/material/AppBar';
import MuiDrawer, { type DrawerProps } from '@mui/material/Drawer';

export const drawerWidth = 300;

interface StyledMainLayoutProps {
  bgColor?: string;
  $isGsChart: boolean;
}

export const StyledMainLayout = emotionStyled.div<StyledMainLayoutProps>`
  background: ${(props) => props.bgColor || '#fff'};

  .MuiAppBar-root {
    width: 100% !important;
  }

  .MuiDrawer-root {
    overflow-y: scroll;
    height: 100vh;
  }

  .MuiContainer-root {
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    height: inherit;
    
    
    .contents {
      width: 100%;
      height: inherit;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  main {
    margin-top: 52px;
  }

  .footer {
    position: absolute;
    width: 100%;
    bottom: 0 !important;
    background: #fff !important;
    z-index: 1200;

    > footer {
      background: #fff !important;
    }
  }

  ${({ $isGsChart }) =>
    $isGsChart &&
    `
    background: var(--color-black);

      .footer {
        background: #071312 !important;

        > footer {
          background:  #071312 !important;
          border-top: none !important;

          .copylight {
            color: var(--color-white) !important;
          }
        }
      }
  `}
`;

interface StyledAppBarProps extends Partial<AppBarClasses> {
  open?: boolean;
  $isGsChart: boolean;
}

export const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== '$isGsChart'
})<StyledAppBarProps>(({ theme, open, $isGsChart }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...($isGsChart && {
    background: '#000'
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

interface StyledDrawerProps extends DrawerProps {
  open?: boolean;
  $isGsChart: boolean;
}

export const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== '$isGsChart'
})<StyledDrawerProps>(({ theme, open, $isGsChart }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    boxSizing: 'border-box',
    '.version': {
      marginBottom: '39px',
      marginLeft: '11px',
      fontSize: '16px'
    },
    ...(!open && {
      overflowX: 'hidden',
      padding: '0',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: 0,
      '.version': {
        marginBottom: '39px',
        marginLeft: '11px',
        fontSize: '16px'
      }
    }),
    ...($isGsChart && {
      background: 'rgba(4, 4, 4, 0.6)',
      boxShadow: '0px 0px 11.5px 0px rgba(13, 175, 160, 0.6) inset'
    })
  }
}));
